import { render, staticRenderFns } from "./indesign.vue?vue&type=template&id=76dbd937&"
import script from "./indesign.vue?vue&type=script&lang=js&"
export * from "./indesign.vue?vue&type=script&lang=js&"
import style0 from "./indesign.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports